import './loader.css'
import {useEffect, useState} from "react";

const ImageLoader = (props) => {
    const {style, loaderClassName, className, src, loading, loadingBlob, zoomvalue, bwFilter, bluewhiteFilter, onLoad: onLoadProp, ...rest} = props;
    const [internalLoading, setInternalLoading] = useState(true);
    // Undecodable src (e.g. a raw HEIC blob on desktop) -> show the loader instead of a
    // broken-image icon, and recover automatically once src becomes the server URL.
    const [imgError, setImgError] = useState(false);

    // Check if src is a data URL (client-side cropped image)
    const isClientCroppedImage = src && typeof src === 'string' && src.startsWith('data:image');

    // Check if src is a blob URL (already in memory, loads instantly)
    const isBlobUrl = src && typeof src === 'string' && src.startsWith('blob:');

    // Check if this is a clean frame type image
    const isCleanFrameType = className && className.includes('clean');

    useEffect(() => {
        // Reset loading state when src changes
        setInternalLoading(true);
        setImgError(false);

        // If it's a client-side cropped image or blob URL, we can set loading to false immediately
        // since these are already loaded in memory
        if (isClientCroppedImage || isBlobUrl) {
            setInternalLoading(false);
        }
    }, [src, isClientCroppedImage, isBlobUrl]);

    let imgStyle = {...style};

    // Determine if we should show the blob preview (unzoomed images use blob directly)
    const isBlob = (zoomvalue === "0" || zoomvalue === 0) && loadingBlob && !isClientCroppedImage;

    // Determine which class to use - blob uses loader class, final uses main class
    const getClassName = () => {
        if (isBlob) return loaderClassName;
        if (internalLoading && loadingBlob) return loaderClassName; // Use loader class for blob preview
        return className;
    };
    const fullClassName = getClassName();

    // Determine which filter class to apply (mutual exclusivity: bwFilter takes precedence)
    let filterClassName = fullClassName;
    if (bwFilter) {
        filterClassName = fullClassName + " grayscale-filter";
    } else if (bluewhiteFilter) {
        filterClassName = fullClassName + " bluewhite-filter-style";
    }

    // Determine which image source to show:
    // 1. If isBlob (unzoomed with blob available), show blob
    // 2. If still loading and have a blob preview, show blob as fallback
    // 3. Otherwise show the main src
    const getImageSrc = () => {
        if (isBlob) return loadingBlob;
        if (internalLoading && loadingBlob) return loadingBlob; // Show blob preview while final image loads
        return src;
    };

    return (
        <>
            <img
              src={getImageSrc()}
              // Lazy-load networked images so off-screen grid items don't all fetch at once.
              // In-memory blob:/data: sources (fresh uploads, client crops) load eagerly.
              loading={isBlobUrl || isClientCroppedImage ? 'eager' : 'lazy'}
              decoding="async"
              className={filterClassName}
              style={{
                ...imgStyle,
                display: 'block', // Always show - we're managing src dynamically instead
                // Hide a failed decode (e.g. HEIC blob on desktop) so no broken-image
                // icon flashes; the loader below shows until a working src arrives.
                ...(imgError ? { visibility: 'hidden' } : {}),
                // Apply high-quality rendering for clean frame type
                ...(isCleanFrameType ? {
                  imageRendering: '-webkit-optimize-contrast',
                  transform: 'translateZ(0)',
                  backfaceVisibility: 'hidden'
                } : {})
              }}
              onLoad={() => {
                  setImgError(false);
                  if(!isBlob){
                      setInternalLoading(false);
                      if (onLoadProp) onLoadProp();
                  }
              }}
              onError={() => { setImgError(true); }}
              alt=''
            />
            {/* Hidden image to preload the final src while showing blob preview */}
            {internalLoading && loadingBlob && !isBlob && src && (
              <img
                src={src}
                style={{ display: 'none' }}
                onLoad={() => {
                    setInternalLoading(false);
                    if (onLoadProp) onLoadProp();
                }}
                alt=''
              />
            )}
            {(loading || imgError) && <div className="roling-loader"><img
                /*src="../assets/images/Rolling.svg"*/
                style={{position: "absolute", 'zIndex': "1000", left: '35%', top: '33%'}}
                //alt="rolling"
                alt=""
            /></div>
            }
        </>
    );
}

export default ImageLoader;
